var map = {
	"./nage-no-kata/Harai-goshi.webp": 9467,
	"./nage-no-kata/Kata-guruma.webp": 3662,
	"./nage-no-kata/Okuri-ashi-harai.webp": 3101,
	"./nage-no-kata/Sasae-tsurikomi-ashi.webp": 8696,
	"./nage-no-kata/Seoi-nage.webp": 6117,
	"./nage-no-kata/Sumi-gaeshi.webp": 9213,
	"./nage-no-kata/Tomoe-nage.webp": 715,
	"./nage-no-kata/Tsurikomi-goshi.webp": 5459,
	"./nage-no-kata/Uchi-mata.webp": 3924,
	"./nage-no-kata/Uki-goshi.webp": 1642,
	"./nage-no-kata/Uki-otoshi.webp": 3585,
	"./nage-no-kata/Uki-waza.webp": 1086,
	"./nage-no-kata/Ura-nage.webp": 4885,
	"./nage-no-kata/Yoko-gake.webp": 7178,
	"./nage-no-kata/Yoko-guruma.webp": 4297
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5038;